import { POWER_PAST_DUE_MESSAGE } from './payments';

export const ReferrerTypes = {
    MEMBER: 'member',
    CLUB: 'club',
};

export const ReferralLandingErrorTypes = {
    ALREADY_SUBSCRIBED: 'already_subscribed',
    INVALID_CODE: 'invalid_code',
    DELETED_ACCOUNT: 'deleted_account',
    PAST_DUE: 'past_due',
};

export const ReferralLandingCtaLabels = {
    GET_POWER: 'Get Power',
    CONTINUE: 'Continue',
    RESUME_POWER: 'Resume Power',
};

export const ReferralLandingMessages = {
    [ReferralLandingErrorTypes.ALREADY_SUBSCRIBED]: 'You\'re already a UTR Power Annual member.',
    [ReferralLandingErrorTypes.INVALID_CODE]: 'This offer isn\'t currently available.',
    [ReferralLandingErrorTypes.DELETED_ACCOUNT]: 'This code is no longer active.',
    [ReferralLandingErrorTypes.PAST_DUE]: POWER_PAST_DUE_MESSAGE,
};

// Shown, in a neutral (non-error) style, when a member lands on their own referral link. Not an
// error state — there is simply nothing for them to redeem through their own code.
// Placeholder wording, pending final copy from Design/PM.
export const REFERRAL_SELF_REFER_MESSAGE = 'This is your referral link — share it with a friend to start earning.';

// Shown in the same neutral style to a viewer the landing marks ineligible (isEligible: false) —
// anyone who has ever been a Power subscriber (monthly, or a lapsed former subscriber). Referral
// offers are for new annual subscribers. A soft eligibility notice, not an error, so it renders
// black rather than in the red error treatment.
export const REFERRAL_INELIGIBLE_MESSAGE = 'At this time, referral codes are for New Annual subscribers.';

export const ReferralApplyErrorTypes = {
    INVALID_CODE: 'invalid_code',
    SELF_REFERRAL: 'self_referral',
    INELIGIBLE: 'ineligible',
    DISABLED_REFERER: 'disabled_referer',
    OFFER_UNAVAILABLE: 'offer_unavailable',
    OFFER_UNAVAILABLE_LOCATION: 'offer_unavailable_location',
    REQUEST_FAILED: 'request_failed',
};

export const ReferralApplyErrorMessages = {
    [ReferralApplyErrorTypes.INVALID_CODE]: 'This code isn\'t valid. Double-check and try again.',
    [ReferralApplyErrorTypes.SELF_REFERRAL]: 'You can\'t use your own referral code.',
    [ReferralApplyErrorTypes.INELIGIBLE]: 'This referral can\'t be applied to your account.',
    [ReferralApplyErrorTypes.DISABLED_REFERER]: 'This referral link is no longer active.',
    [ReferralApplyErrorTypes.OFFER_UNAVAILABLE]: 'This offer isn\'t currently available.',
    [ReferralApplyErrorTypes.OFFER_UNAVAILABLE_LOCATION]: 'This referral offer isn\'t available in your region. The code has been removed.',
    [ReferralApplyErrorTypes.REQUEST_FAILED]: 'Something went wrong — please try again.',
};

// The referral state endpoints answer 403 when a referrer's own code has been disabled, which is
// a legitimate account state rather than a failure worth retrying.
export const REFERRALS_FORBIDDEN_HTTP_STATUS = 403;

export const REFERRALS_NOT_AVAILABLE_MESSAGE = 'Referrals are not currently available for your account.';

export const REFERRAL_CLEAR_ERROR_MESSAGE = 'Couldn\'t remove that code — please try again.';
